import script from "./LandingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingPage.vue?vue&type=script&setup=true&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=d9e9bf80&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9e9bf80"]])

export default __exports__